exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#subject-text[data-v-3222411e] {\n    margin: 0;\n    max-width: 45vw;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n#subject-text[data-v-3222411e]:first-letter {\n    text-transform: uppercase;\n}\n", ""]);

// exports
